import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default: DON'T refetch on window focus (reduces request spam)
      // Individual queries can enable it if needed (e.g., notification-stats)
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes default stale time
      // Don't poll by default - only poll where explicitly needed
      refetchInterval: false,
      refetchIntervalInBackground: false,
      // Don't refetch on mount by default (prevents remount spam)
      refetchOnMount: false,
    },
  },
});



